import { AfterViewInit, Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CompanyDetail } from '@classes/company-detail';
import { CustomerGridViewItem } from '@classes/customer-grid-view-item';
import { Role } from '@enums/role.enum';
import { CompanyService } from 'app/core/services/company.service';
import { UiService } from 'app/core/services/ui.service';

@Component({
  selector: 'app-customer-grid',
  templateUrl: './customer-grid.component.html',
  styleUrls: ['./customer-grid.component.scss']
})
export class CustomerGridComponent implements OnInit, AfterViewInit {

  @Output() companyEmit = new EventEmitter<CompanyDetail>();


  dataSource = new MatTableDataSource<CustomerGridViewItem>();
  pageSizeOptions = [25, 50, 100];
  selectedRowID: string;
  displayedColumns: string[] = [
    'name',
  ];

  nameFilter = new FormControl('');
  filterValues = {
    name: '',
  };
  Role = Role;

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  // @ViewChild(MatPaginator, { static: true }) MatPaginatorIndex: MatPaginator;
  @ViewChild('search') searchElement: ElementRef;

  constructor(
    public companyService: CompanyService,
    public uiService: UiService
  ) { }
  ngOnInit() {
    this.getCustomers();

    this.nameFilter.valueChanges
      .subscribe(
        name => {
          this.filterValues.name = name;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
  }

  getCustomers() {
    this.uiService.addRouteLoading();
    this.companyService.getCompanies(true).subscribe(companies => {
      this.dataSource.data = companies
        .sort((a, b) => ((a.name || "") > (b.name || "")) ? 1 : (((b.name || "") > (a.name || "")) ? -1 : 0))
        .map(m => new CustomerGridViewItem({
          id: m.id,
          name: m.name
        }));
      if (companies.length == 1) {
        this.selectItemClick(this.dataSource.data[0]);
      }
      this.uiService.removeRouteLoading();
    }, error => {
      console.error(error);
      this.uiService.removeRouteLoading();
    })
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.searchElement.nativeElement.focus();
    });
    this.dataSource.sort = this.sort;
    this.dataSource.filterPredicate = this.createFilter();
  }

  selectItemClick(item: CustomerGridViewItem) {
    this.selectedRowID = item.id || '';
    if (this.selectedRowID) {
      this.uiService.addRouteLoading();
      this.companyService.getCompany(this.selectedRowID).subscribe(company => {
        const companyDetail = new CompanyDetail({
          id: this.selectedRowID,
          isReadOnlyMode: true,
          company: company
        });
        this.companyEmit.emit(companyDetail);
        this.uiService.removeRouteLoading();
      }, error => {
        console.error(error);
        this.uiService.removeRouteLoading();
      })
    }
  }

  onCreateNewCustomer() {
    const companyDetail = new CompanyDetail({
      isCreationMode: true
    });
    this.companyEmit.emit(companyDetail);
  }

  createFilter(): (data: any, filter: string) => boolean {
    let filterFunction = function (data: { name: string; }, filter: string): boolean {
      let searchTerms = JSON.parse(filter);
      return data.name.toLowerCase().indexOf(searchTerms.name) !== -1
        ;
    }
    return filterFunction;
  }


}
